import { render, staticRenderFns } from "./FooterPart.vue?vue&type=template&id=2ee6fb39&scoped=true"
import script from "./FooterPart.vue?vue&type=script&lang=js"
export * from "./FooterPart.vue?vue&type=script&lang=js"
import style0 from "./FooterPart.vue?vue&type=style&index=0&id=2ee6fb39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee6fb39",
  null
  
)

export default component.exports